/**
 * Class MoreContainer
 *
 * @requires jQuery
 *
 * @param {Function} $
 */
window.Widgets.StripeCore.MoreContainer = (($) => {
    /**
     * Initialisiert eine MoreContainer-Instanz, welcher optional der Container
     * 	übergeben werden kann. Sollte hier kein Container übergeben werden, dann
     * 	kann dies über die .bind Methode auch nachträglich gemacht werden.
     *
     * Falls Inhalts-Sektionen zugewiesen werden, bevor ein Container via .bind
     * 	zugewiesen wird, dann werden diese Sektionen zwischengespeichert, bis
     * 	ein gültiger Container zugewiesen wird.
     *
     * Sollte der Container später via .bind gewechselt werden, so werden die
     * 	Sektionen mit in den neuen Container übernommen.
     *
     * @public
     * @constructor
     *
     * @param {jQuery} container
     */
    function MoreContainer(container) {
        this.sectionData = []
        this.moreAjaxCount = 0

        if (undefined !== container) {
            this.bindToContainer(container)
        }
    }

    MoreContainer.prototype = {
        /**
         * @var {jQuery}
         * @private
         */
        containerElement: null,

        /**
         * @var {jQuery}
         * @private
         */
        buttonElement: null,

        /**
         * @var {DocumentFragment[]}
         * @private
         */
        sectionData: null,

        /**
         * @var {string}
         * @private
         */
        rootSelector: ".page-stripe",

        /**
         * @var {string}
         * @private
         */
        sectionSelector: ".more-content",

        /**
         * @var {string}
         * @private
         */
        openSectionRootClass: "more-is-open",

        /**
         * @var {string}
         * @private
         */
        displaySectionClass: "show",

        /**
         * @var {number}
         * @private
         */
        moreAjaxCount: 0,

        /**
         * @var {string}
         * @private
         */
        ajaxUrl: "",

        /**
         * @var {Object}
         * @private
         */
        ajaxParams: null,

        /**
         * Weist der Instanz den zugehörigen Container zu
         *
         * @public
         * @param {jQuery} container
         * @return {MoreContainer}
         */
        bindToContainer: function (container) {
            if (null !== this.containerElement && this.sectionData.length > 0) {
                this.removeSectionsFromOldContainer(this.containerElement)
            }

            this.containerElement = container

            if (this.sectionData.length > 0) {
                this.appendSectionsToContainer()
            }

            return this
        },

        /**
         * @public
         * @return {jQuery}
         */
        container: function () {
            return this.containerElement
        },

        /**
         * @public
         */
        updateAjaxParams: function () {
            this.ajaxParams = this.buttonElement.data("ajaxParams")

            if (this.ajaxParams.moreCount > 0) {
                this.moreAjaxCount = this.ajaxParams.moreCount
            }
        },

        /**
         * @public
         * @param {jQuery} buttonElement
         */
        addButtonEvent: function (buttonElement) {
            if (null !== this.buttonElement) {
                this.buttonElement.off("click", this.showNextContentSectionOrClose.bind(this, 1))
            }

            this.buttonElement = buttonElement
            this.buttonElement.on("click", this.showNextContentSectionOrClose.bind(this, 1))

            if (this.buttonElement.data("ajaxUrl")) {
                this.ajaxUrl = this.buttonElement.data("ajaxUrl")
                this.updateAjaxParams()
            }

            return this
        },

        /**
         * @public
         * @return {jQuery}
         */
        button: function () {
            return this.buttonElement
        },

        /**
         * Fügt dem aufklappbaren Container eine neue Inhalts-Sektion hinzu
         *
         * @public
         * @param {string} sectionContent
         * @return {MoreContainer}
         */
        addSection: function (sectionContent, showSection) {
            const sectionFragment = document.createDocumentFragment()
            const content = $("<section />")
            let sectionCount = this.sectionData.length

            content.addClass(`${this.sectionSelector.substr(1)} row section-${++sectionCount}`).html(sectionContent)

            if (showSection === "1") {
                content.addClass("show")
            }

            content.appendTo(sectionFragment)
            this.sectionData.push(sectionFragment)

            if (null !== this.containerElement) {
                this.containerElement.append(sectionFragment)
            }

            $(document).trigger("added.more:section", [this])

            return this
        },

        /**
         * @public
         * @param {number} step
         */
        openTo: function (step) {
            this.showNextContentSectionOrClose(step)
        },

        /**
         * @private
         * @param {jQuery} oldContainer
         */
        removeSectionsFromOldContainer: function (oldContainer) {
            for (const section in this.sectionData) {
                if (!this.sectionData.hasOwnProperty(section)) {
                    continue
                }

                oldContainer.find(section).remove()
            }
        },

        /**
         * Fügt dem neuen Container alle hinterlegten Sektionen hinzu
         *
         * @private
         */
        appendSectionsToContainer: function () {
            for (const section in this.sectionData) {
                if (!this.sectionData.hasOwnProperty(section)) {
                    continue
                }

                this.containerElement.append(section)
            }
        },

        /**
         * @private
         * @param {number} amount
         * @param {Event} [clickEvent]
         */
        showNextContentSectionOrClose: function (newAmount, clickEvent) {
            if (undefined !== clickEvent) {
                clickEvent.preventDefault()
            }

            let amount = newAmount
            if (!amount) {
                amount = 1
            }

            const openInstant = !clickEvent
            const sections = this.containerElement.find(`section${this.sectionSelector}`)
            const hiddenSections = sections.filter(":hidden")

            if (!this.moreAjaxCount && !hiddenSections.length) {
                this.closeContainerAndHideSections(sections)
                return
            }

            if (this.moreAjaxCount > 0) {
                this.fetchMoreAjaxData(amount, openInstant)
            } else {
                this.showSectionsAndCalculateHeight(hiddenSections.slice(0, amount), openInstant)
            }
        },

        /**
         * @private
         * @param {jQuery} sections
         * @param {boolean} [instant]
         */
        showSectionsAndCalculateHeight: function (sections, instant, ajaxData) {
            const currentHeight = this.containerElement.height()
            let newHeight
            let sectionCount
            let sectionIndex = 0

            if (ajaxData) {
                ajaxData.wasAjaxRequest = false
            }

            if (!sections.length) {
                return
            }

            this.containerElement.removeClass("quick-open")

            if (!instant) {
                this.containerElement.css("height", currentHeight)
            }

            newHeight = 0 + currentHeight

            sections.addClass(this.displaySectionClass)

            for (sectionCount = sections.length; sectionIndex < sectionCount; sectionIndex++) {
                newHeight += $(sections.get(sectionIndex)).outerHeight()
            }

            const lastSectionId = sections
                .last()
                .prop("class")
                .match(/section-(\d+)/i)
                .pop()

            window.setTimeout(
                function () {
                    if (!instant) {
                        // Nach dem öffnen des Containers wird die height auf auto gesetzt, damit
                        // 	Elemente, die innerhalb aufklappbar sind, die Höhe des Containers beeinflussen
                        this.containerElement.off("transitionend")
                        this.containerElement.one(
                            "transitionend",
                            function (sectionId) {
                                window.setTimeout(
                                    function () {
                                        $(document).trigger("shown.more:transition", [this])

                                        this.containerElement
                                            .trigger("shown.more:transition", [Number.parseInt(sectionId, 10)])
                                            .addClass("quick-open")
                                            .css("height", "auto")
                                    }.bind(this),
                                    15,
                                )
                            }.bind(this, lastSectionId),
                        )
                    } else {
                        newHeight = "auto"
                    }

                    $(document).trigger("show.more:transition", [this, ajaxData])
                    this.containerElement
                        .trigger("show.more:transition", [Number.parseInt(lastSectionId, 10), ajaxData])
                        .css("height", newHeight)

                    if (
                        !this.containerElement.find(`section${this.sectionSelector}:hidden`).length &&
                        !this.moreAjaxCount
                    ) {
                        this.containerElement.closest(this.rootSelector).addClass(this.openSectionRootClass)
                    }
                }.bind(this),
                15,
            )
        },

        /**
         * @private
         * @param {jQuery} sections
         */
        closeContainerAndHideSections: function (sections) {
            const currentHeight = this.containerElement.height()

            if (this.ajaxParams) {
                this.ajaxParams.wasAjaxRequest = false
            }

            this.containerElement.removeClass("quick-open")

            this.containerElement.css("height", currentHeight)
            this.containerElement.closest(this.rootSelector).removeClass(this.openSectionRootClass)

            window.setTimeout(
                function () {
                    this.containerElement.off("transitionend")
                    this.containerElement.one(
                        "transitionend",
                        function (sectionsToHide) {
                            let sectionCount
                            let sectionIndex = 0

                            for (sectionCount = sectionsToHide.length; sectionIndex < sectionCount; sectionIndex++) {
                                $(sectionsToHide.get(sectionIndex)).removeClass(this.displaySectionClass)
                            }

                            $(document).trigger("closed.more:transition", [this])
                            this.containerElement.trigger("closed.more:transition")
                        }.bind(this, sections),
                    )

                    $(document).trigger("close.more:transition", [this])
                    this.containerElement.trigger("close.more:transition").css("height", 0)
                }.bind(this),
                15,
            )
        },

        /**
         * Sendet einen Request an die hinterlegte REST-Schnittstelle, um
         * 	weitere Stripe-Daten auszulesen
         *
         * @private
         * @param {number} fetchCount
         * @param {boolean} instant
         */
        fetchMoreAjaxData: function (fetchCount, instant) {
            this.buttonElement.addClass("loading")
            this.ajaxParams.jumpTo = fetchCount

            this.ajaxParams.wasAjaxRequest = true

            $.get(this.ajaxUrl, this.ajaxParams)
                .done(this.addAjaxSectionDataOnSuccess.bind(this, fetchCount, instant))
                .error(this.displayAjaxErrorWarning.bind(this))
        },

        /**
         * Erstellt für alle zurückgegebenen Daten die entsprechenden Sektionen
         * 	an und öffnet diese anschließend. Außerdem wird der Zähler für
         * 	AJAX-Calls verringert, damit die Klasse weiß, wann keine Daten mehr
         * 	nachgeladen werden müssen.
         *
         * @private
         * @param {number} fetchCount
         * @param {boolean} instant
         * @param {string} moreData
         * @param {string} ajaxStatus
         * @param {XMLHttpRequest} xhr
         */
        addAjaxSectionDataOnSuccess: function (fetchCount, instant, moreData, ajaxStatus, xhr) {
            this.buttonElement.removeClass("loading")

            if ("success" !== ajaxStatus || 200 !== xhr.status) {
                this.displayAjaxErrorWarning()

                return
            }

            const ajaxData = JSON.parse(moreData)
            let ajaxDataIndex = 0
            let ajaxDataCount
            const sectionData = []

            // Filtriere alle nicht-nummerische Keys
            for (const dataKey in ajaxData) {
                if (!ajaxData.hasOwnProperty(dataKey) || Number.isNaN(dataKey)) {
                    continue
                }

                sectionData.push(ajaxData[dataKey])
            }

            ajaxDataCount = sectionData.length

            this.moreAjaxCount -= fetchCount
            this.ajaxParams.moreCount = this.moreAjaxCount

            for (; ajaxDataIndex < ajaxDataCount; ajaxDataIndex++) {
                this.addSection(sectionData[ajaxDataIndex])
            }

            const sections = this.containerElement.find(`section${this.sectionSelector}`)
            const hiddenSections = sections.filter(":hidden")

            this.showSectionsAndCalculateHeight(hiddenSections.slice(0, fetchCount), instant, ajaxData)
        },

        /**
         * Zeigt die Fehler-Meldung in der Konsole, dass ein gestarteter
         * 	AJAX-Request fehlgeschlagen ist
         *
         * @private
         */
        displayAjaxErrorWarning: function () {
            console.error(
                "%cMore-Buttons [%c%s%c] - AJAX:%c die Anfrage konnte nicht " + "erfolgreich abgeschlossen werden",

                "color: #c00; font-weight: bold",
                "color: #46e; font-style: italic",
                this.containerElement.closest(this.rootSelector).prop("id"),
                "color: #c00; font-style: normal",
                "color: initial; font-weight: normal",
            )
        },
    }

    return MoreContainer
})($)
